import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterDakdekkerPage() {
  return <ClusterPageTemplate clusterName="Dakdekker" sectorName="Bouw & Installatie" sectorSlug="bouw-installatie" heroTitle="Website laten maken voor een dakdekker" heroDescription="Een betrouwbare, professionele website voor jouw dakdekkersbedrijf. Wij bouwen websites die lokaal goed gevonden worden en direct leads opleveren." websiteOnderdelen={[{
    icon: 'BriefcaseIcon',
    title: 'Diensten',
    description: "Heldere pagina's voor dakrenovatie, dakreparatie, isolatie en het verhelpen van lekkages."
  }, {
    icon: 'CameraIcon',
    title: 'Projecten',
    description: "Laat je vakmanschap zien met voor-en-na foto's van recent opgeleverde daken."
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Garantie & Keurmerken',
    description: 'Bouw vertrouwen op door duidelijk te communiceren over je garantietermijnen en certificaten.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Gratis dakinspectie',
    description: 'Een speciale landingspagina om laagdrempelig aanvragen voor dakinspecties te genereren.'
  }]} functionaliteiten={[{
    icon: 'SearchIcon',
    title: 'Lokale SEO',
    description: "Optimalisatie voor zoektermen als 'dakdekker [jouw regio]' en 'daklekkage verhelpen'."
  }, {
    icon: 'FileTextIcon',
    title: 'Offerteformulier',
    description: "Een formulier waarmee klanten direct foto's van hun dak kunnen uploaden voor een snelle prijsindicatie."
  }, {
    icon: 'PhoneIcon',
    title: 'Spoed contact',
    description: 'Een opvallende click-to-call knop voor mensen die met spoed een daklekkage willen laten verhelpen.'
  }]} siblingClusters={[{
    name: 'Bouwbedrijf',
    slug: 'bouwbedrijf'
  }, {
    name: 'Loodgieter',
    slug: 'loodgieter'
  }, {
    name: 'Elektricien',
    slug: 'elektricien'
  }]} faqs={[{
    q: 'Wat kost een website voor een dakdekkersbedrijf?',
    a: 'Een professionele, conversiegerichte website start vanaf €1.500. We maken graag een voorstel op maat op basis van jouw wensen.'
  }, {
    q: 'Hoe zorg ik voor meer aanvragen voor dakinspecties?',
    a: 'We richten de website conversiegericht in met duidelijke call-to-actions en een speciaal, laagdrempelig formulier voor gratis dakinspecties.'
  }, {
    q: "Kan ik foto's van afgeronde projecten laten zien?",
    a: "Ja, we bouwen een overzichtelijke portfoliomodule in waar je heel eenvoudig zelf voor-en-na foto's van daken kunt toevoegen."
  }, {
    q: 'Zijn jullie websites goed vindbaar in Google?',
    a: 'Absoluut. Lokale vindbaarheid is onze specialiteit. We zorgen dat de technische SEO perfect staat zodat je lokaal goed rankt.'
  }]} data-id="element-1078" />;
}